
    <div class="generic-border__header bold">{{ header }}</div>
    <div class="generic-border__container">
      <ng-content></ng-content>
    </div>
